module.exports = __webpack_public_path__ + "static/media/IMG_2838.7ac9d0dd.jpg";